import React from "react";
import "./ContactCTA.scss";
import { useScrollReveal } from "../../../motion/useScrollReveal";

const CONTACT_URL = "https://www.nagarro.com/en/contact-us";


const ContactCTA: React.FC = () => {
  const openExternal = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // Subtitle then button rise + fade in as the section scrolls into view.
  const revealRef = useScrollReveal<HTMLDivElement>({
    selector: ".contact-cta__subtitle, .contact-cta__actions",
    stagger: 0.15,
  });

  return (
    <section id="contact" className="contact-cta" aria-label="Contact Nagarro">
        <div className="contact-cta__inner" ref={revealRef}>
          <p className="contact-cta__subtitle">
            From a single title to a full platform Nagarro takes you end to end,
            across every market.
          </p>
          <div className="contact-cta__actions">
            <button
              type="button"
              className="contact-cta__btn contact-cta__btn--primary"
              onClick={() => openExternal(CONTACT_URL)}
            >
              Contact Us
            </button>
          </div>
        </div>
      </section>
  );
};

export default ContactCTA;
